export default "__VITE_ASSET__DiinrHl1__"